import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface RDrawerContextProps {
  isVisible: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
  toggleDrawer: () => void;
  drawerWidth: number;
  headerHeight: number;
  setDrawerWidth: (width: number) => void;
  setHeaderHeight: (height: number) => void;
}

const RDrawerContext = createContext<RDrawerContextProps | undefined>(undefined);

interface RDrawerProviderProps {
  children: ReactNode;
  initialDrawerWidth?: number;
  initialHeaderHeight?: number;
}

export const RDrawerProvider = ({
  children,
  initialDrawerWidth = 275,
  initialHeaderHeight = 0,
}: RDrawerProviderProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState(initialDrawerWidth);
  const [headerHeight, setHeaderHeight] = useState(initialHeaderHeight);

  const openDrawer = () => setIsVisible(true);
  const closeDrawer = () => setIsVisible(false);
  const toggleDrawer = () => setIsVisible((v) => !v);

  return (
    <RDrawerContext.Provider
      value={{
        isVisible,
        openDrawer,
        closeDrawer,
        toggleDrawer,
        drawerWidth,
        headerHeight,
        setDrawerWidth,
        setHeaderHeight,
      }}
    >
      {children}
    </RDrawerContext.Provider>
  );
};

export const useRDrawer = (): RDrawerContextProps => {
  const context = useContext(RDrawerContext);
  if (!context) {
    throw new Error('useDrawer must be used within a DrawerProvider');
  }
  return context;
};
